module.exports = __webpack_public_path__ + "img/standard-definition.64b5641b.svg";